import { runtimeConfig } from '@components/service-and-repair/services/base-url-config';

/*
  Stock-number resolution for the exterior-cosmetic spinner-location step.

  The experiment gate itself uses the experimentation API
  (GetExperiment(Experiments.COSMETIC_EXTERIOR_LOCATION) in router-provider → SarStore →
  locations.tsx). This file only resolves WHICH vehicle the spinner should render:

    1. ?stock=<n> query override — a demo/debug tool. Honored ONLY in non-prod, because
       it lets the caller force an arbitrary vehicle; in prod that would drive the
       record-creating upload-damage-images call against a vehicle the user may not own.
       (The backend must still authorize stockNumber against the caller's identity.)
    2. The owned vehicle's real stock number from the feed
       (content.serviceAndRepair.stockNumber, added to MyCars.API on SERV-563).
    3. null — no spinner. The locations step falls back to the classic tile list
       rather than render a vehicle that isn't the customer's.
*/

const isProdEnvironment = (): boolean => {
  const env = runtimeConfig.getEnvironment();
  return env === 'prod' || env === 'production';
};

export const resolveStockNumber = (feedStockNumber?: number | null): number | null => {
  if (!isProdEnvironment()) {
    try {
      const params = new URLSearchParams(window.location.search);
      const s = params.get('stock');
      if (s && /^\d+$/.test(s)) return Number(s);
    } catch {
      /* ignore */
    }
  }

  return typeof feedStockNumber === 'number' && feedStockNumber > 0 ? feedStockNumber : null;
};
